import { createContext, useEffect, useRef, useState } from "react";
import axios from "axios";

export const TotalDriverContext = createContext();

export const TotalDriverProvider = ({ children }) => {
    const [locations, setLocations] = useState([]);
    const socketRef = useRef(null);
    const reconnectAttempts = useRef(0);
    const MAX_RECONNECT_ATTEMPTS = 10;

    const fetchOnlineDrivers = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL}/api/drivers/nearbyCabs`, {
                withCredentials: true
            });


            setLocations(res.data.onlinelocation);
        } catch (err) {
            console.error("Failed to fetch online driver count:", err);
        }
    };

    const connectWebSocket = () => {
        // socketRef.current = new WebSocket(`wss://webapicab.tech:8086`);
        socketRef.current = new WebSocket(process.env.REACT_APP_WEBSOCKET_URL);


        socketRef.current.onopen = () => {
            console.log('✅ WebSocket connection established');
            reconnectAttempts.current = 0; // reset on successful connection
        };

        socketRef.current.onmessage = (event) => {
            const parsedMessage = JSON.parse(event.data);

            if (parsedMessage.type === 'StatusUpdate') {
                const newData = parsedMessage.data;
                setLocations(prev => {
                    const updated = [...prev];
                    newData.forEach(incoming => {
                        const index = updated.findIndex(loc => loc.cab_id === incoming.cab_id);
                        if (incoming.status === 'offline') {
                            if (index !== -1) updated.splice(index, 1);
                        } else {
                            if (index !== -1) updated[index] = incoming;
                            else updated.push(incoming);
                        }
                    });
                    return updated;
                });
            }

            if (parsedMessage.type === 'LocationUpdate') {
                const newLocations = parsedMessage.data;
                setLocations(prev => {
                    const updated = [...prev];
                    newLocations.forEach(loc => {
                        const index = updated.findIndex(item => item.cab_id === loc.cab_id);
                        if (index !== -1) {
                            updated[index] = {
                                ...updated[index],
                                lat: loc.lat,
                                lng: loc.lng,
                                timestamp: loc.timestamp
                            };
                        }
                    });
                    return updated;
                });
            }
            if (parsedMessage.type === 'NetworkUpdate') {
                console.log('Network update received:', parsedMessage.data);
                const updates = parsedMessage.data;

                setLocations(prev => {
                    const updated = [...prev];
                    updates.forEach(update => {
                        const index = updated.findIndex(item => item.cab_id === update.cabId);
                        if (index !== -1) {
                            updated[index] = {
                                ...updated[index],
                                connected: update.connected
                            };
                            console.table(update.connected)
                        }
                    });
                    return updated;
                });
                // Handle network updates if needed
            }
        };

        socketRef.current.onerror = (err) => {
            console.error('❌ WebSocket error:', err);
        };

        socketRef.current.onclose = () => {
            console.warn('⚠️ WebSocket connection closed');
            attemptReconnect();
        };
    };

    const attemptReconnect = () => {
        if (reconnectAttempts.current < MAX_RECONNECT_ATTEMPTS) {
            const timeout = Math.min(1000 * 2 ** reconnectAttempts.current, 30000); // exponential backoff up to 30s
            reconnectAttempts.current += 1;
            console.log(`🔄 Attempting to reconnect in ${timeout / 1000}s...`);

            setTimeout(() => {
                connectWebSocket();
            }, timeout);
        } else {
            console.error('🛑 Max reconnection attempts reached. Giving up.');
        }
    };

    useEffect(() => {
        fetchOnlineDrivers();
        connectWebSocket();

        // Cleanup on unmount
        return () => {
            if (socketRef.current) {
                socketRef.current.close();
            }
        };
    }, []);

    return (
        <TotalDriverContext.Provider value={{ locations }}>
            {children}
        </TotalDriverContext.Provider>
    );
};
